import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

const blink = keyframes`0%, 100% { fill: #E6E0F5; } 50% { fill: #FFE08A; }`;
const bob = keyframes`0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); }`;

/** While the Office (three.js and the models) downloads: a little building whose windows light up in turn. */
export default function OfficeLoading({ label = 'Opening the office…' }: { label?: string }) {
  const windows = [0, 1, 2].flatMap(r => [0, 1, 2].map(c => ({ r, c })));
  return (
    <Box role="progressbar" aria-label={label} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5, py: 10 }}>
      <Box component="svg" width={72} height={84} viewBox="0 0 72 84" sx={{ animation: `${bob} 1.6s ease-in-out infinite` }}>
        <rect x="10" y="14" width="52" height="64" rx="8" fill="#FBE0E7" />
        <rect x="22" y="6" width="28" height="12" rx="5" fill="#D9C8FF" />
        {windows.map(({ r, c }) => (
          <Box component="rect" key={`${r}${c}`} x={18 + c * 14} y={22 + r * 14} width={9} height={9} rx={2.5}
            sx={{ fill: '#E6E0F5', animation: `${blink} 1.8s ease-in-out infinite`, animationDelay: `${(r * 3 + c) * 0.18}s` }} />
        ))}
        <rect x="30" y="64" width="12" height="14" rx="3" fill="#FFB8C9" />
        <ellipse cx="36" cy="80" rx="30" ry="3" fill="#3F3A52" opacity="0.12" />
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>{label}</Typography>
    </Box>
  );
}
